module.exports = __webpack_public_path__ + "c4afab58a0779090c413123b6c71f732.MP3";